export const DATA_QA_INTRO_CONTAINER = 'intro-container';
export const DATA_QA_CONTINUE_BUTTON = 'continue-button';
export const IS_LEMANA_PRO_ANIMATION_SHOWN_COOKIE = 'isLemanaProAnimationShown';
export const CHANGE_POSITION_TIME = 7000;
export const MODAL_CLOSE_TIME_DELAY = 5000;
export const DELAY_TIME = 300;
export const SHOW_HINT_TIME = CHANGE_POSITION_TIME + DELAY_TIME;
export const ONE_YEAR = 60 * 60 * 24 * 365;
